import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { helperGetStaticContentUrl } from 'helpers/RouteHelper';
import sharedTheme from '../OverlayTheme.css';
import theme from './theme.css';

const RetryError = (props = {}) => {
  const { onRetryClick, background, statusCode, enabled } = props;
  const {
    error_failureRetryMessage: retryMessage,
    error_failureRetryTitle: retryTitle,
  } = window.Language;
  const retryIcon = helperGetStaticContentUrl('images/svg', 'icon_retry.svg');

  if (!enabled) return null;

  return (
    <div className={sharedTheme.container}>
      <img
        className={classNames([sharedTheme.background, theme.imageBackground])}
        src={background}
        alt=""
      />
      <div className={sharedTheme.messageContainer}>
        <div className={classNames(theme.retryTitle, sharedTheme.title)}>{retryTitle}</div>
        <div className={classNames(theme.retryMessage, sharedTheme.title)}>{retryMessage}</div>
        <div className={classNames(theme.retryButton, sharedTheme.message)}>
          <a className={theme.button} onClick={onRetryClick}>
            <img className={theme.retryIcon} src={retryIcon} alt="retry icon" /> Retry
          </a>
        </div>
        <div className={classNames(theme.retryCode, sharedTheme.title)}>
          ERROR CODE {statusCode}
        </div>
      </div>
    </div>
  );
};

RetryError.propTypes = {
  background: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  onRetryClick: PropTypes.func.isRequired,
  statusCode: PropTypes.number.isRequired,
};

export default RetryError;
